import React from "react";
import { useSelector } from "react-redux";
import { loadStorage } from "../../Utils/Utils";

const AccountDetails = () => {
    const userData = useSelector((store) => store.user.data) || loadStorage("user");

    return (
        <div className="col-lg-8 col-md-8 col-12">
            <div className="ml-0 ml-md-4">
                <div className="d-none d-md-block">
                    <div className="row mb-md-5">
                        <div className="col">
                            <h5 className="mb-1 text-white">Account Details</h5>
                            <p className="mb-0 text-white small">
                                You have full control to manage your own Account.
                            </p>
                        </div>
                    </div>
                </div>
                <div className="card">
                    <div className="card-body">
                        <div>
                            <form className="row align-items-end">
                                <div className="mb-3 col-12 col-md-6">
                                    <label className="form-label" htmlFor="fname">First Name</label>
                                    <input type="text" id="fname" className="form-control" placeholder="First Name" value={userData?.firstName ?? ''} disabled/>
                                </div>
                                <div className="mb-3 col-12 col-md-6">
                                    <label className="form-label" htmlFor="lname">Last Name</label>
                                    <input type="text" id="lname" className="form-control" placeholder="Last Name" value={userData?.lastName ?? ''} disabled/>
                                </div>
                                <div className="mb-3 col-12 col-md-6">
                                    <label className="form-label" htmlFor="fname">Phone</label>
                                    <input type="text" id="fname" className="form-control" placeholder="Phone" value={userData?.phone ?? ''} disabled/>
                                </div>
                                <div className="mb-3 col-12 col-md-6">
                                    <label className="form-label" htmlFor="fname">Email</label>
                                    <input type="text" id="fname" className="form-control" placeholder="Email" value={userData?.email ?? ''} disabled/>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default AccountDetails;